import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { listPrevisionnels } from "@/lib/previsionnels";

/** LOT 40 — Sélecteur du prévisionnel de référence utilisé par un rapport. */
export default function PrevisionnelSelect({ dossierId, value, onChange, disabled, testId = "previsionnel-ref-select" }) {
    const [list, setList] = useState([]);
    useEffect(() => {
        listPrevisionnels(dossierId).then((r) => { setList(r || []); if (!value && r && r[0]) onChange(r[0].id); }).catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dossierId]);
    return (
        <div className="space-y-1.5">
            <label className="text-sm text-muted-foreground">Prévisionnel à joindre en annexe <span className="text-destructive">*</span></label>
            <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
                <SelectTrigger data-testid={testId} className="h-10 bg-background"><SelectValue placeholder="Sélectionner un prévisionnel…" /></SelectTrigger>
                <SelectContent>{list.map((p) => <SelectItem key={p.id} value={p.id}>{p.titre}</SelectItem>)}</SelectContent>
            </Select>
        </div>
    );
}
